import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/repertoire-agroalimentaire-chaudiere-appalaches_logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-29220136"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Logo Répertoire agroalimentaire Chaudière-Appalaches (RACA)"
}, null, -1))
const _hoisted_2 = { class: "liens" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Inscription")
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", null, [
    _createVNode(_component_router_link, {
      to: '/',
      title: "Page d'accueil RACA",
      class: "flex-gauche"
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, {
          to: '/inscription',
          title: "Page d'inscription au site"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("a", {
          href: _ctx.loginLink(),
          title: "Lien de connexion"
        }, "Connexion", 8, _hoisted_4)
      ])
    ])
  ]))
}